<template>
 <div class="inner-wrapper">
    <div class="inner-wrapper-md">
  <div class="row">
    <div class="col-12">
      <h4 class="page-title">Password successfully reset!</h4>

      <p class="body">
        The password for the account <span class="label-active">{{this.Email}}</span> has been successfully updated. You can now log in to your account.
      </p>
      <div class="form-row cta-group">
        <router-link class="cta-white-227" :to="{ name: 'signin' }">
          Proceed to sign in <span class="angle-right-white"></span></router-link
        >
      </div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>

//import { publicRouter } from '../router'
import {  mapState } from "vuex";

export default {
  name: "PasswordResetSuccess",
  
  computed:{
     ...mapState("account", ["status"]),
      Email: {
      get() {
        return this.status.Email;
      }//,
      // set(val) {
      //   this.$store.commit(`account/${RESETPASSWORD}`,{email: val });
      // }
    }
  },
 
};
</script>

<style lang="scss" scoped></style>
